import { render } from "./SubcategoriasProduto.vue?vue&type=template&id=b76dcbb2&scoped=true"
import script from "./SubcategoriasProduto.vue?vue&type=script&lang=js"
export * from "./SubcategoriasProduto.vue?vue&type=script&lang=js"

import "./SubcategoriasProduto.vue?vue&type=style&index=0&id=b76dcbb2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b76dcbb2"]])

export default __exports__